const baseStyle = {
  fontFamily: `heading`,
  fontWeight: `bold`,
  color: `#48494c`,
  whiteSpace: `pre-line`,
};

const sizes = {
  '4xl': {
    fontSize: [`4xl`, null, `7xl`],
    lineHeight: 1,
  },
  '3xl': {
    fontSize: [`3xl`, null, `6xl`],
    lineHeight: 1.3,
  },
  '2xl': {
    fontSize: [`3-5xl`, null, null, `4-5xl`],
    lineHeight: 1.2,
  },
  xl: {
    fontSize: [`3xl`, null, `4xl`],
    lineHeight: [1.33, null, 1.2],
  },
  lg: {
    fontSize: [`2xl`, null, `3xl`],
    lineHeight: [1.33, null, 1.2],
  },
  'lg-md': {
    fontSize: [`lg`, null, `2-5xl`],
    lineHeight: [1.33, null, 1.2],
  },
  md: { fontSize: `2xl`, lineHeight: 1.2 },
  sm: { fontSize: `md`, lineHeight: 1.2 },
  xs: { fontSize: `sm`, lineHeight: 1.2 },
};

const defaultProps = {
  size: `xl`,
};

export default {
  baseStyle,
  sizes,
  defaultProps,
};
